
import React from 'react'
import { ArrowForward } from "@mui/icons-material"

import "./customicons.css"

export const ArrowForwardIcon = ({ disabled, onClick }) => {

  return (
   
    <div>
      <ArrowForward className = "iconArrow" onClick = {onClick}/>
    </div> 

  )
}
  




